import {
  FETCH_BASIC_DASHBOARD_DATA_REQUEST,
  FETCH_BASIC_DASHBOARD_DATA_SUCCESS,
  FETCH_BASIC_DASHBOARD_DATA_FAILURE,
} from '../Services/fetchBasicDashboardData';

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BASIC_DASHBOARD_DATA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_BASIC_DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
      };

    case FETCH_BASIC_DASHBOARD_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
